import React from 'react';
import SplashScreenStickersFP from '../FullPagesComponents/OnBoarding/SplashScreenStickersFP';
import SplashScreenSecurityFP from '../FullPagesComponents/OnBoarding/SplashScreenSecurityFP';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import {
  Android,
  splash_screen_one,
  splash_screen_Stickers,
  splash_screen_three,
  splash_screen_two,
} from '../../../utils/DictionaryManagementUtils';
import {
  img_scr_2b_and, img_scr_logo_android, img_scr_logo_ios,
} from '../../../utils/ImagesManagementUtils';
import { xlateText } from '../../../utils/Utils';
import SplashScreenMainFP from '../FullPagesComponents/OnBoarding/SplashScreenMainFP';
import SplashScreenIntroFP from '../FullPagesComponents/OnBoarding/SplashScreenIntroFP';

//= ========================================================================

const PromotionDF = ({ globJSON, simPlatform, slideshowRefs }) => {
  const { promotion } = globJSON.configurations.onboarding;
  const scr3Security = promotion.onboarding_screen_3_is_security;
  return (
    <SimulatorsViewerArrangement>
      <SplashScreenIntroFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        imageSource={simPlatform === Android ? img_scr_logo_android : img_scr_logo_ios}
        LabelInputText={xlateText(promotion.promo_text_1)}
        TopTitle={splash_screen_one}
        slideshowRefs={slideshowRefs}
      />
      <SplashScreenMainFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        imageSource={simPlatform === Android && img_scr_2b_and}
        LabelInputText={xlateText(promotion.promo_text_2)}
        TopTitle={splash_screen_two}
        withStatusBar
        slideshowRefs={slideshowRefs}
      />
      {scr3Security ? (
        <SplashScreenSecurityFP
          globJSON={globJSON}
          simPlatform={simPlatform}
          imageSource={simPlatform === Android && img_scr_2b_and}
          LabelInputText={promotion.promo_text_4}
          TopTitle={splash_screen_three}
          withStatusBar
          slideshowRefs={slideshowRefs}
        />
      ) : (
        <SplashScreenStickersFP
          globJSON={globJSON}
          simPlatform={simPlatform}
          imageSource={simPlatform === Android && img_scr_2b_and}
          LabelInputText={promotion.promo_text_3}
          TopTitle={splash_screen_Stickers}
          withStatusBar
        />
      )}
    </SimulatorsViewerArrangement>
  );
};

export default PromotionDF;
